var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("competence-cards-filters-data-provider", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(dataProvider) {
          return _c(
            "div",
            { staticClass: "c-form  competence-cards-fitlters" },
            [
              _c("div", { staticClass: "o-grid" }, [
                _c(
                  "div",
                  {
                    staticClass: "o-grid__column",
                    attrs: { "data-size": "sm:12 md:6 lg:3" }
                  },
                  [
                    _c("vue-input", {
                      ref: "nameFilter",
                      staticClass: "c-form__item",
                      attrs: {
                        label: "Filtrera på namn",
                        "input-id": "nameFilter",
                        type: "text",
                        value: dataProvider.appliedFilters.name,
                        disabled: _vm.disabled
                      },
                      on: { input: dataProvider.setNameFilter }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "o-grid__column",
                    attrs: { "data-size": "sm:12 md:6 lg:3" }
                  },
                  [
                    _c("dropdown-variations", {
                      ref: "competenceFilter",
                      attrs: {
                        "item-groups": dataProvider.competenceFilterOptions,
                        label: "Filtrera på kompetensområde",
                        value:
                          dataProvider.appliedFilters &&
                          dataProvider.appliedFilters.competence
                            ? dataProvider.appliedFilters.competence
                            : {},
                        filterable: true,
                        resettable: true,
                        disabled: _vm.disabled
                      },
                      on: { selectedItem: dataProvider.setCompetenceFilter }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "o-grid__column",
                    attrs: { "data-size": "sm:12 md:6 lg:3" }
                  },
                  [
                    _c("dropdown-variations", {
                      ref: "courseFilter",
                      attrs: {
                        "item-groups": dataProvider.courseFilterOptions,
                        label: "Filtrera på kurskategori",
                        value:
                          dataProvider.appliedFilters &&
                          dataProvider.appliedFilters.course
                            ? dataProvider.appliedFilters.course
                            : {},
                        filterable: true,
                        resettable: true,
                        disabled: _vm.disabled
                      },
                      on: { selectedItem: dataProvider.setCourseFilter }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "o-grid__column",
                    attrs: { "data-size": "sm:12 md:6 lg:3" }
                  },
                  [
                    _c("dropdown-variations", {
                      ref: "workplaceFilter",
                      attrs: {
                        "item-groups": dataProvider.workplaceFilterOptions,
                        label: "Filtrera på arbetsställe",
                        value:
                          dataProvider.appliedFilters &&
                          dataProvider.appliedFilters.workplace
                            ? dataProvider.appliedFilters.workplace
                            : {},
                        filterable: true,
                        resettable: true,
                        disabled: _vm.disabled
                      },
                      on: { selectedItem: dataProvider.setWorkplaceFilter }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "o-grid__column",
                    attrs: { "data-size": "sm:12" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "t-margin-bottom-m" },
                      [
                        _c("vue-input", {
                          ref: "expiringFilter",
                          attrs: {
                            type: "checkbox",
                            label: "Visa endast utgående kurser/intyg",
                            "input-id": "expiring",
                            checked: dataProvider.appliedFilters.expiring,
                            disabled: _vm.disabled
                          },
                          on: { checked: dataProvider.setExpiringFilter }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", [
                      dataProvider.appliedFilters &&
                      dataProvider.sortDirection === "descending"
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "c-button c-button--linkstyle c-button--reset",
                              attrs: { id: "ascending" },
                              on: {
                                click: function($event) {
                                  return dataProvider.setSortDirection(
                                    "ascending"
                                  )
                                }
                              }
                            },
                            [
                              _c("vue-icon", {
                                attrs: {
                                  name: "arrow-down",
                                  size: "c-icon--17px"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "t-margin-left-xs" }, [
                                _vm._v("Sortera A-Ö")
                              ])
                            ],
                            1
                          )
                        : _c(
                            "button",
                            {
                              staticClass:
                                "c-button c-button--linkstyle c-button--reset",
                              attrs: { id: "descending" },
                              on: {
                                click: function($event) {
                                  return dataProvider.setSortDirection(
                                    "descending"
                                  )
                                }
                              }
                            },
                            [
                              _c("vue-icon", {
                                attrs: {
                                  name: "arrow-up",
                                  size: "c-icon--17px"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "t-margin-left-xs" }, [
                                _vm._v("Sortera Ö-A")
                              ])
                            ],
                            1
                          )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "o-grid__column",
                    attrs: { "data-size": "sm:12" }
                  },
                  [
                    dataProvider.competenceCards.length === 0 &&
                    dataProvider.anyFiltersApplied
                      ? _c(
                          "div",
                          { staticClass: "t-text-align-center t-margin-top-m" },
                          [
                            _vm._v("\n\t\t\t\t\tInga träffar, vill du "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "c-button c-button--linkstyle c-button--reset",
                                on: { click: _vm.resetAllFilters }
                              },
                              [_vm._v("nollställa alla filter")]
                            ),
                            _vm._v("?\n\t\t\t\t")
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ])
            ]
          )
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }